import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { FullscreenOverlayV2 } from '../../../organisms/FullscreenOverlayV2';

import { CancellationReasonFormV2 } from './CancellationReasonFormV2';
import { ICancellationReasonFormState } from './types';

interface ICancellationReasonOverlayV2Props {
	open: boolean;
	onClose: () => void;
	withDelayReason: boolean;
	hasCancellationFee: boolean;
	onSubmit: (values: ICancellationReasonFormState) => Promise<void>;
	isCancelling: boolean;
}

export const CancellationReasonOverlayV2: FC<
	ICancellationReasonOverlayV2Props
> = ({
	open,
	onClose,
	withDelayReason,
	hasCancellationFee,
	onSubmit,
	isCancelling,
}) => {
	const { t } = useTranslation('booking');

	return (
		<FullscreenOverlayV2
			open={open}
			onClose={onClose}
			title={t('booked.cancel.reason.slider_title')}
			testId="cancellationReasonOverlayV2"
		>
			<CancellationReasonFormV2
				withDelayReason={withDelayReason}
				hasCancellationFee={hasCancellationFee}
				onSubmit={onSubmit}
				isCancelling={isCancelling}
			/>
		</FullscreenOverlayV2>
	);
};
